import { cva } from '@/styled-system/css';

export const upsellBannerRootRecipe = cva({
  base: {
    'display': 'flex',
    'flexDirection': {
      lgDown: 'column',
    },
    'alignItems': {
      lg: 'center',
    },
    'justifyContent': {
      lg: 'center',
    },
    'borderRadius': 'none',
    'paddingBlock': 'default',
    'paddingInline': 'default',
    'paddingInlineStart': {
      lgDown: 'calc({spacing.default} + {sizes.icon.xl} + {spacing.default})',
    },
    'position': 'relative',

    '&:has([data-c11n-component="UpsellBanner.CloseButton"]) [data-c11n-component="UpsellBanner.Media"]':
      {
        marginInlineStart: {
          lg: 'auto',
        },
      },
  },
  variants: {
    tone: {
      neutral: {
        backgroundColor: 'bg.neutral',
      },
      soft: {
        backgroundColor: 'UpsellBanner.Root.soft.bg',
      },
      hero: {
        backgroundColor: 'UpsellBanner.Root.hero.bg',
      },
      impact: {
        backgroundColor: 'bg.express.trust.impact',
      },
    },
  },
});
